export enum ArticuloHistorialTipo{
    Creacion,           //Cuando el articulo es creado
    Modificacion,       //Cuando el articulo es modificado
    Eliminacion,        //Cuando el articulo es eliminado
    Compra,             //Cuando se compra un articulo
    AnulacionCompra,    //Cuando se Anula una compra
    Venta,              //Cuando se vende un articulo
    AnulacionVenta,     //Cuando se anula una venta
    Envio,              //Cuando se envia un articulo por transferencia
    AnulacionEnvio,     //Cuando se anula un envio
    Recepcion,          //Cuando se recibe un articulo por transferencia
    AnulacionRecepcion, //Cuando se anula una recepcion
    Entrada,            //Cuando entra un articulo por otras razones
    AnulacionEntrada,   //Cuando se anula una entrada
    Salida,             //Cuando sale un articulo por otras razones
    AnulacionSalida,    //Cuando se anula una salida
}

export type ArticuloHistorial = {
    id:string,
    articuloId:string,
    tipo:ArticuloHistorialTipo,
    cantidadInicial:number,
    cantidadFinal:number,
    cantidad:number,
    fecha:string,
    usuarioId:string,
    usuarioNombre:string
}